/**
 * Meta Pixel helper.
 * Base pixel loaded in public/index.html; here we expose helpers to fire
 * Standard Events from anywhere in the React app.
 */

export function fbTrack(event, params) {
  if (typeof window === "undefined") return;
  if (typeof window.fbq !== "function") return;
  try {
    if (params) window.fbq("track", event, params);
    else window.fbq("track", event);
  } catch (e) {
    // silent
  }
}

export const fbPageView = () => fbTrack("PageView");

export const fbViewContent = (product) => {
  if (!product) return fbTrack("ViewContent");
  fbTrack("ViewContent", {
    content_ids: [product.product_id],
    content_name: product.name,
    content_type: "product",
    content_category: product.category,
    value: Number(product.price) || 0,
    currency: "INR",
  });
};

export const fbAddToCart = (product) => {
  if (!product) return fbTrack("AddToCart");
  fbTrack("AddToCart", {
    content_ids: [product.product_id],
    content_name: product.name,
    content_type: "product",
    value: Number(product.price) || 0,
    currency: "INR",
  });
};

export const fbPurchase = (order) => {
  if (!order) return;
  fbTrack("Purchase", {
    value: Number(order.total) || 0,
    currency: order.currency || "INR",
    content_ids: (order.items || []).map((i) => i.product_id),
    content_type: "product",
    num_items: (order.items || []).reduce((n, i) => n + (i.quantity || 1), 0),
  });
};
